const applicationServerPublicKey = 'BGlXha0pSS-P0ltTmzvk8bYP9fPXn7uMxEC5b_YHCboFMa5kzn8JhGhmefROqGvw9mdp3EQXer7A_na_T87i-uc'

export {
  applicationServerPublicKey
}
